import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

function Awarding({awardingData}) {

    //console.log(awardingData);

    return (
        <>
            {
                awardingData ?
                    <section className="mb-20">
                        <div className="container mx-auto position-relative relative">
                            <img src={awardingData.awarding_photo} className="block w-full rounded-t-2xl sm:rounded-b-2xl"/>
                            <div
                                className="lg:absolute bottom-9 left-0 right-0 m-auto text-center text-[#e7e9ec] w-full lg:w-4/5 lg:w-3/5 px-5 sm:px-10 lg:px-20 py-12 bg-[#001D53]/90 rounded-b-2xl sm:rounded-t-2xl">
                                <ScrollAnimation animateIn="animate__fadeInUp"><h6 className="bg-[#F3FF80] w-max px-3 py-1 mb-4 m-auto rounded-2xl text-[#001D53]">ТОП-100</h6></ScrollAnimation>
                                <ScrollAnimation animateIn="animate__fadeInUp"><h2 className="text-4xl mb-4">{awardingData.awarding_title}</h2></ScrollAnimation>
                                <ScrollAnimation animateIn="animate__fadeInUp"><p>{awardingData.awarding_text}</p></ScrollAnimation>
                            </div>
                        </div>
                    </section>  : ''
            }
        </>
    )
}

export default Awarding